import React from 'react'
import PageLayout from '../templates/PageLayout';
import Cite from "citation-js";

function yearComparison(citA, citB) {
    return citA.issued['date-parts'][0][0] - citB.issued['date-parts'][0][0]
}

function processFile(pubs, file) {
    pubs.setState(oldState => {
        const newPubs = new Cite(file).format('data', {format: 'object'});
        const existingKeys = oldState.pubObjs.map(e => e["citation-label"]);

        //sort by year, if published in the same year, by the first author name then second author, etc
        newPubs.sort(yearComparison);

        const allPubs = [];

        let i;
        const iterations = newPubs.length + oldState.pubObjs.length;
        for (i = 0; i < iterations; i++) {
            if (newPubs.length === 0) {
                allPubs.push(oldState.pubObjs.shift());
            } else if (oldState.pubObjs.length === 0) {
                allPubs.push(newPubs.shift());
            } else {
                console.log('new');
                console.log(newPubs);
                console.log('existing');
                console.log(oldState.pubObjs);

                const comparison = yearComparison(newPubs[0], oldState.pubObjs[0]);
                if (comparison > 0)
                    allPubs.push(oldState.pubObjs.shift());
                else
                    allPubs.push(newPubs.shift());
            }

        }


        console.log(allPubs);

        return {pubObjs: allPubs}
    });
}

function requestFiles(pubs, files) {
    files.forEach(f => fetch('data/publications/' + f)
        .then(response => response.text().then(result => processFile(pubs, result)))
        .catch(reason => console.log('Error: ' + reason))
    )
}

class Publications extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pubObjs: []
        }
    }

    componentDidMount() {
        fetch('data/publications/files.json')
            .then(response => response.json())
            .then(files => requestFiles(this, files))
            .catch(reason => console.log('Error: ' + reason))
    }


    render() {
        const strings = [];
        const cite = new Cite();

        this.state.pubObjs.forEach(obj => strings.push(cite.set(obj).format('bibliography', {template: 'apa'})))

        return <PageLayout>
            <h2>Project Publications</h2>
            <ul>{strings.map(s => <li><b>{s}</b></li>)}</ul>
        </PageLayout>;

    }
}

export default Publications;